import Model  from '@/util/models';

export default class User extends Model { 
    backend = '/master/user/';         
    
    setavatar(formdata){
        return this.api.post(this.backend + 'setavatar', formdata, null, {
          'accept': 'application/json',
          'Accept-Language': 'en-US,en;q=0.8',
          'Content-Type': `multipart/form-data; boundary=${formdata._boundary}`,
        });
    }
    
    getavatar(params){
        return this.api.get(this.backend + 'getavatar', params); 
    }
    
    getavatarThumb(params){
        return this.api.get(this.backend + 'getavatar-thumb', params); 
    }

    profile(){
        return this.api.get(this.backend + 'profile');
    }
    
    updateProfile(body){
        return this.api.post(this.backend + 'profile-update', body);
    }
            
}

